import "leaflet-editable";
import { Button } from "antd";
import styled from "styled-components";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import useMapHelper from "./helper";

const Style = styled.div`
  height: 400px;
    
  .map-container {
    flex: 1;
    overflow: hidden;

    .leaflet-control {
      opacity: 0;
    }
  }
`

export default function PolygonSelector({
  value,
  onChange = () => { },
  canEdit = true,
  label,
  country = '',
}) {
  const container = useRef();
  const { t } = useTranslation();

  const { clear } = useMapHelper({
    container,
    value,
    canEdit,
    onChange,
    country 
  });

  return (
    <Style className="flex-c row-item">
      <label className="label">{label}</label>
      <div
        className="map-container"
        ref={container}
      />
      {(value && canEdit) ? (
        <Button
          onClick={clear}
        >
          {t('Clear')}
        </Button>
      ) : null}
    </Style>
  );
}
